import React, {memo, useMemo} from "react"
import {useHistory} from "react-router-dom"
import {onClickHandler} from "../../../utils/onclick"
import {useSelector} from "react-redux"
import { useLocalization } from "../../../hooks/localization"
import fullscreen from "../../../assets/images/icons/fullscreen.png"
type Props = {
    amountStatus: (order: number) => void
    amount: number
    label: string
    page: number
}
export const AmountField = memo(function AmountField({amountStatus, label, amount, page}: Props) {
    const history = useHistory()
    const {t} = useLocalization()
    const energyControlList = useSelector(state => state.control.energyState)

    const amountType = useMemo(() => {
        switch (energyControlList.currency_unit) {
            case "try":
                return (
                    <>
                        <span>{amount?.toFixed(2)}</span>
                        <span>₺</span>
                    </>
                )
            case "usd":
                return (
                    <>
                        <span>$</span>
                        <span>{amount?.toFixed(2)}</span>
                    </>
                )
            case "eur":
                return (
                    <>
                        <span>€</span>
                        <span>{amount?.toFixed(2)}</span>
                    </>
                )
            case "gbp":
                return (
                    <>
                        <span>£</span>
                        <span>{amount?.toFixed(2)}</span>
                    </>
                )
        }
    }, [energyControlList, amount])
    return (
        <div className="energy-box">
            <span>
                <span>{t("energy_page.consumption_amount")}</span>
                <span>
                    <button
                        {...onClickHandler(() => amountStatus(1))}
                        className={`${label === "hour" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.hour")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(2))}
                        className={`${label === "day" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.day")}
                    </button>
                    <button
                        {...onClickHandler(() => amountStatus(3))}
                        className={`${label === "month" ? "energy-active-button" : ""}`}
                    >
                        {t("energy_page.month")}
                    </button>
                    <img className="energy-fullscreen" src={fullscreen} alt="" onClick={() => history.push(`/energy/${page}`)}/>
                </span>
            </span>
            <div className="energy-page" onDoubleClick={() => history.push(`/energy/${page}`)}>
                <div className="energy-amount-text">{amountType}</div>
            </div>
        </div>
    )
})
